// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { infoCardsStyles } from "@conklin/App/Widgets/InfoCards/InfoCards";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

const responsiveCardWidth = css`
    ${xScreen("lte", "md")} {
        width: calc((100% - 24px) / 2);
    }

    ${xScreen("lte", "sm")} {
        width: 100%;
    }
`;

infoCardsStyles.container = {
    css: css`
        gap: 22px 24px;
        display: flex;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            gap: 20px 24px;
        }
        ${xScreen("lte", "sm")} {
            gap: 24px;
        }
        @media print {
            page-break-inside: avoid;
        }
    `,
};
infoCardsStyles.content = {
    css: css`
        width: 100%;
        ${({ numberOfCards }: any) => {
            if (numberOfCards >= 4) {
                return css`
                    width: calc((100% - 72px) / 4);
                    ${responsiveCardWidth}
                `;
            }
            if (numberOfCards === 3) {
                return css`
                    width: calc((100% - 48px) / 3);
                    ${responsiveCardWidth}
                `;
            }
            if (numberOfCards === 2) {
                return css`
                    width: calc((100% - 24px) / 2);
                    ${responsiveCardWidth}
                `;
            }
        }};
    `,
};
